import React from 'react';

import { Tag } from 'antd';

import loanTypeName from '~/common/loanTypeName';
import { ProductTagsContainer } from './styled';

type ProductTagsData = {
  usedFutureMargin: boolean;
  loanType: string;
  suggestedOfferType?: string;
};

type ProductTagsProps = {
  data: ProductTagsData;
};

const colors = {
  PORTABILITYWITHOUTREFIN: 'magenta',
  FUTUREMARGIN: 'green',
  PORTABILITY: 'orange',
  REFIN: 'red',
  NEW: 'blue',
};

export default function ProductTags({ data: { usedFutureMargin, loanType, suggestedOfferType } }: ProductTagsProps) {
  return (
    <ProductTagsContainer>
      <Tag color={colors?.[suggestedOfferType] || colors?.[loanType]}>
        <span>{loanTypeName(loanType, suggestedOfferType)}</span>
      </Tag>
      {usedFutureMargin && (
        <Tag>
          <span>Margem 35%</span>
        </Tag>
      )}
    </ProductTagsContainer>
  );
}
